import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelUser } from "@src/types/user-management";

export interface PutUpdateUsersResult {
  success: boolean;
  data?: ZitadelUser;
  error?: string;
}

export const patchUpdateUserUseCase = async (
  user: Partial<ZitadelUser>,
): Promise<PutUpdateUsersResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchUpdateUser(namespace, user);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to update user. Please try again later.",
      ).message,
    };
  }
};
